<template>
  <div class="playback">
    <template v-if="!isLoading">
    <h2 class="medium-title">
      Playback summary
    </h2>
    <div class="playback__wrapper__header__functionality">
          <div class="playback__wrapper__header__functionality__left">
            <adx-selectdropdown ref="campaignDropdown" @selected="selectCampaign" :options="campaignList" :value.sync="selectedCampaign" />
            <div :class="['dropdown']">
              <label class="small-font">Tanggal Awal</label>
              <v-date-picker
                v-model='startDate'
                :max-date='new Date(Date.now()-864e5)'
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                class='date-input'>
                <input
                  class="calendar-start"
                  placeholder= "DD/MM/YYYY"
                  type='text'
                  slot-scope='{ inputValue, updateValue }'
                  :value='inputValue'
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
            </div>
            <div :class="['dropdown']">
              <label class="small-font">Tanggal Akhir</label>
              <v-date-picker
                v-model='endDate'
                :max-date='new Date(Date.now()-864e5)'
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                class='date-input'>
                <input
                  class="calendar-start"
                  placeholder= "DD/MM/YYYY"
                  type='text'
                  slot-scope='{ inputValue, updateValue }'
                  :value='inputValue'
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
            </div>
            <div><button class="btn-regular primary" @click="submit"> Submit </button></div>
            <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
          </div>
          <div><button class="btn-regular primary" @click="download">Download</button></div>
    </div>
    <table>
     <thead>
       <tr>
        <th class="header"> Device </th>
        <th class="header"> Playback Ratio </th>
        <th class="header"> Hardware Uptime Ratio </th>
        <th class="header"> Network Uptime Ratio </th>
       </tr>
     </thead>
     <tbody>
       <tr v-for="(item, index) in devices" :key="index">
        <td class="column">{{ item.device }}</td>
        <td class="column">{{ item.playback_ratio }}%</td>
        <td class="column">{{ item.hardware_uptime }}%</td>
        <td class="column">{{ item.network_uptime }}%</td>
       </tr>
     </tbody>
    </table>
     <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" 
        :maxPage="maxPage" @change-page="selectPage"/></div>
     <div class="emptyState"><adx-empty-selection v-if="isEmpty && !loading" /></div>
     </template>
     <template v-else>
      <div class="playback__loading">
        <adx-loading />
      </div>
    </template>
  </div>

</template>

<script>
import calendar from 'v-calendar'
import EmptySelection from '@/components/NotFound/Selection'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Pagination from '@/components/Pagination'
import Loading from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment';
import FileSaver from 'file-saver';

const {
  helpers,
  validate
} = validationLib
export default {
  name: 'adx-playback_summary',
  components: {
    'adx-loading': Loading,
    'adx-empty-selection': EmptySelection,
    'adx-pagination': Pagination,
    'adx-selectdropdown': SelectDropdown,
    'adx-modal': Modal
  },
  props: {

  },
  data() {
    return {
      startDate: null,
      endDate: null,
      isSchedules: false,
      searchText: '',
      dataModal: null,
      isCreateSaved: false,
      isLoading: false,
      isEmpty: false,
      maxPage: 0,
      selectedPage: 1,
      selectedCampaign: 0,
      searchBoxValue: '',
      month: null,
      devices: [],
      schedules: [],
      campaignList: [{id:0, value: 0, label: 'No campaign'}],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      years: null,
      yearsOptions: [],
      selectedYears: null,
      selectedMonth: null,
    } 
  },
  computed: {
    filtered: function(){
      let filtered = false
      if (this.selectedCampaign !=0){
        filtered = true
      }
      return filtered
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    if (this.$route.query.title) {
      this.searchBoxValue = this.$route.query.title
    }

    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }

    this.startDate = new Date(Date.now()-864e5)
    this.endDate = new Date(Date.now()-864e5)
    this.getCampaignList()
    this.getDevices()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {
  
  },
  updated() {
    
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectCampaign(item){
      this.selectedCampaign = item.item.value
    },
    download(){
      let endDate = this.endDate
      let startDate = this.startDate
      let id = this.selectedCampaign

      if (startDate) {
        startDate = moment(startDate).format('YYYY-MM-DD')
        endDate = moment(endDate).format('YYYY-MM-DD')
      } else {
        startDate = ''
        endDate = ''
      }

      (async() => {
        let param = {
          from: startDate,
          to: endDate
        }
        const response = await api.get(
          apiV2.playbackReport(id),
          { needToken: true, responseType: 'blob', params: param })
        if (response.status == 200) {
          const fileName = `Device Performance Report.xlsx`
          await FileSaver.saveAs(response.data, fileName);
        } else {
          let error = 'Bad Request'
          if (response.status === 403) error = 'Forbidden'
          if (response.status === 500) error = 'Internal Server Error'
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: error,
            type: 'danger'
          });
        }
      })();
    },
    submit(){
      this.selectedPage = 1
      this.getDevices()
    },
     selectPage(item) {
      this.selectedPage = item
      this.getDevices()
    },
    getDevices() {
      (async () => {
        let startDate = moment(this.startDate).format('YYYY-MM-DD')
        let endDate = moment(this.endDate).format('YYYY-MM-DD')
        this.isLoading = true
        let param = {
          start: startDate,
          end: endDate,
          campaign: this.selectedCampaign,
          page: this.selectedPage
        }
        const response = await api.get(apiV2.devicesPlayback, { needToken: true, params: param })
        if (response.status == 200) {
          this.devices = response.data.results
          this.isLoading = false
          this.maxPage = response.data.max_page
        }
      })();
    },
    getCampaignList(){
      (async () => {
        let dataCampaign = null
        const response = await api.get(apiV2.listCampaign, { needToken: true})
        if (response.status == 200){
          dataCampaign = response.data
          let campaign = dataCampaign.map(list => {
            return {
              id: list.id,
              label: `${list.title}`,
              value: list.id
            }
          })
          this.campaignList = this.campaignList.concat(campaign)
        }
      })()
    },
    resetFilter(){
      this.startDate = new Date(Date.now()-864e5)
      this.endDate = new Date(Date.now()-864e5)
      this.$refs.campaignDropdown.onItemClick({id: 0, value: 0, label: 'No campaign'})
      this.getDevices()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .playback {
    .selectDropdown {
      width: auto;
    }
  }
</style>
